// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notes-page .gray-header {
  background: #909092;
  color: white;
  padding: 10px 0 10px 20px; }

.notes-page hr {
  margin-top: 0;
  margin-bottom: 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0; }

.notes-page .note {
  padding-bottom: 5px;
  color: #909092;
  font-size: 12px; }

.notes-page a:hover {
  text-decoration: none; }

.notes-page .note-image {
  width: 65px;
  float: left;
  display: block; }

.notes-page .user-note-row:hover {
  background: #f2f2f2; }

.notes-page .user-note-row {
  position: relative;
  padding-top: 5px;
  padding-left: 5px;
  padding-right: 20px; }
  .notes-page .user-note-row .user-list .user-info {
    padding-left: 65px; }
  .notes-page .user-note-row img {
    width: 55px;
    height: 55px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 5px;
    margin: auto; }
  .notes-page .user-note-row .note {
    padding-top: 5px;
    padding-left: 65px; }

.notes-page .session-note-row, .notes-page .sponsor-note-row {
  position: relative;
  display: block;
  padding-top: 5px;
  min-height: 75px;
  padding-right: 20px; }
  .notes-page .session-note-row .session-name, .notes-page .session-note-row .sponsor-name, .notes-page .sponsor-note-row .session-name, .notes-page .sponsor-note-row .sponsor-name {
    color: black;
    vertical-align: top; }
  .notes-page .session-note-row .note-image, .notes-page .sponsor-note-row .note-image {
    display: inline-block;
    text-align: center;
    width: 65px;
    min-height: 65px; }
    .notes-page .session-note-row .note-image i.fa-calendar, .notes-page .sponsor-note-row .note-image i.fa-calendar {
      color: #dcdcdc;
      padding-top: 5px; }
    .notes-page .session-note-row .note-image img, .notes-page .sponsor-note-row .note-image img {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 5px;
      margin: auto; }

.notes-page .session-note-row a,
.notes-page .sponsor-note-row a {
  display: block;
  overflow: hidden;
  width: 100%; }

.notes-page .sponsor-note-row:hover,
.notes-page .session-note-row:hover,
.notes-page .user-note-row:hover {
  background: #f2f2f2; }

.notes-page .user-icons {
  display: none; }

.notes-page .chevron {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  height: 30%;
  margin: auto; }
  .notes-page .chevron .fa {
    font-size: 1.5em; }

.notes-page .note, .notes-page .session-name, .notes-page .sponsor-name {
  padding-top: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-all;
  word-break: break-word;
  display: block; }

.notes-page .noResults {
  text-align: center;
  font-weight: bold; }
`, "",{"version":3,"sources":["webpack://./src/components/Notes/notes.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB,EAAE;;AAE7B;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,OAAO,EAAE;;AAEX;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EACX,WAAW;EACX,cAAc,EAAE;;AAElB;EACE,mBAAmB,EAAE;;AAEvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB,EAAE;EACrB;IACE,kBAAkB,EAAE;EACtB;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,SAAS;IACT,YAAY,EAAE;EAChB;IACE,gBAAgB;IAChB,kBAAkB,EAAE;;AAExB;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB,EAAE;EACrB;IACE,YAAY;IACZ,mBAAmB,EAAE;EACvB;IACE,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,gBAAgB,EAAE;IAClB;MACE,cAAc;MACd,gBAAgB,EAAE;IACpB;MACE,kBAAkB;MAClB,MAAM;MACN,SAAS;MACT,SAAS;MACT,YAAY,EAAE;;AAEpB;;EAEE,cAAc;EACd,gBAAgB;EAChB,WAAW,EAAE;;AAEf;;;EAGE,mBAAmB,EAAE;;AAEvB;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY,EAAE;EACd;IACE,gBAAgB,EAAE;;AAEtB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc,EAAE;;AAElB;EACE,kBAAkB;EAClB,iBAAiB,EAAE","sourcesContent":[".notes-page .gray-header {\n  background: #909092;\n  color: white;\n  padding: 10px 0 10px 20px; }\n\n.notes-page hr {\n  margin-top: 0;\n  margin-bottom: 0;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  left: 0; }\n\n.notes-page .note {\n  padding-bottom: 5px;\n  color: #909092;\n  font-size: 12px; }\n\n.notes-page a:hover {\n  text-decoration: none; }\n\n.notes-page .note-image {\n  width: 65px;\n  float: left;\n  display: block; }\n\n.notes-page .user-note-row:hover {\n  background: #f2f2f2; }\n\n.notes-page .user-note-row {\n  position: relative;\n  padding-top: 5px;\n  padding-left: 5px;\n  padding-right: 20px; }\n  .notes-page .user-note-row .user-list .user-info {\n    padding-left: 65px; }\n  .notes-page .user-note-row img {\n    width: 55px;\n    height: 55px;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 5px;\n    margin: auto; }\n  .notes-page .user-note-row .note {\n    padding-top: 5px;\n    padding-left: 65px; }\n\n.notes-page .session-note-row, .notes-page .sponsor-note-row {\n  position: relative;\n  display: block;\n  padding-top: 5px;\n  min-height: 75px;\n  padding-right: 20px; }\n  .notes-page .session-note-row .session-name, .notes-page .session-note-row .sponsor-name, .notes-page .sponsor-note-row .session-name, .notes-page .sponsor-note-row .sponsor-name {\n    color: black;\n    vertical-align: top; }\n  .notes-page .session-note-row .note-image, .notes-page .sponsor-note-row .note-image {\n    display: inline-block;\n    text-align: center;\n    width: 65px;\n    min-height: 65px; }\n    .notes-page .session-note-row .note-image i.fa-calendar, .notes-page .sponsor-note-row .note-image i.fa-calendar {\n      color: #dcdcdc;\n      padding-top: 5px; }\n    .notes-page .session-note-row .note-image img, .notes-page .sponsor-note-row .note-image img {\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 5px;\n      margin: auto; }\n\n.notes-page .session-note-row a,\n.notes-page .sponsor-note-row a {\n  display: block;\n  overflow: hidden;\n  width: 100%; }\n\n.notes-page .sponsor-note-row:hover,\n.notes-page .session-note-row:hover,\n.notes-page .user-note-row:hover {\n  background: #f2f2f2; }\n\n.notes-page .user-icons {\n  display: none; }\n\n.notes-page .chevron {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  height: 30%;\n  margin: auto; }\n  .notes-page .chevron .fa {\n    font-size: 1.5em; }\n\n.notes-page .note, .notes-page .session-name, .notes-page .sponsor-name {\n  padding-top: 5px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n  word-break: break-all;\n  word-break: break-word;\n  display: block; }\n\n.notes-page .noResults {\n  text-align: center;\n  font-weight: bold; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
